import cn from 'classnames';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { Paragraph, Text } from '../typography';
import { type FormattedTimeConfig, WidgetItemTimeTag } from './widget-item-time-tag';

export type TagMode = 'live';

type P = {
  activeDate: Date;
  additionalDescription?: ReactNode;
  additionalDescriptionRows?: number;
  alwaysShowTimeTag?: boolean;
  bordered?: boolean;
  className?: string;
  description?: ReactNode;
  descriptionRows?: number;
  icon?: ReactNode;
  item?: ReactNode;
  path: string;
  tags?: TagMode[];
  timeConfig: FormattedTimeConfig;
  title?: string;
};

const WidgetItem = ({
  activeDate,
  additionalDescription,
  additionalDescriptionRows = 2,
  alwaysShowTimeTag = false,
  bordered,
  className,
  description,
  descriptionRows = 2,
  icon,
  item,
  path,
  tags,
  timeConfig,
  title,
}: P) => {
  const { t } = useTranslation();

  return (
    <NavLink className={cn('widget-item', { 'widget-item--bordered': bordered }, className)} to={path}>
      <div className="widget-item__info">
        {(icon ?? title) ? (
          <Text ellipsis size="small">
            {icon}
            {title ? t(title) : null}
          </Text>
        ) : null}
        <WidgetItemTimeTag
          activeDate={activeDate}
          alwaysShowTimeTag={alwaysShowTimeTag}
          tags={tags}
          timeConfig={timeConfig}
        />
      </div>

      {description ? (
        <Paragraph ellipsis={{ rows: descriptionRows }} type="title" weight="bold">
          {description}
        </Paragraph>
      ) : null}

      {additionalDescription ? (
        <Paragraph ellipsis={{ rows: additionalDescriptionRows }} size="small">
          {additionalDescription}
        </Paragraph>
      ) : null}

      {item ? <div>{item}</div> : null}
    </NavLink>
  );
};

export default WidgetItem;
